export function DividerBlock() {
  return <hr className="my-8 border-slate-200" />;
}
